import React from "react";
import founder from "../assets/founder.png";

const AboutSection = () => {
  return (
    <section id="about" className="pt-8 pb-10 md:pt-10 md:pb-20 bg-white relative overflow-hidden border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">

        {/* mobile layout */}
        <div className="lg:hidden">
          {/* title */}
          <div className="mb-5" data-aos="fade-up">
            <h2 className="text-2xl sm:text-3xl font-teko uppercase text-slate-900 mb-3 tracking-wider">
              Founder's Journey
            </h2>
            <p className="text-slate-500 text-xs leading-relaxed text-justify">
              BFI was founded in 2018 with a vision to transform traditional laboratory and
              industrial operations through smart, practical, and scalable software solutions.
              Every software product at BFI is built from real industry problems and practical
              client experiences.
            </p>
          </div>

          {/* content */}
          <div className="relative" data-aos="fade-up">
            {/* picture */}
            <div className="float-right ml-4 mb-3 w-28 sm:w-36 rounded-2xl overflow-hidden border-2 border-slate-100 shadow-lg flex-shrink-0">
              <img
                className="w-full h-auto object-cover"
                src={founder}
                alt="Pravin Kashid – Founder"
              />
              <div className="bg-blue-900 py-1.5 px-2 text-center">
                <p className="text-[9px] font-bold uppercase tracking-wider text-blue-200">
                  Pravin Kashid
                </p>
                <p className="text-[8px] text-white/60 uppercase tracking-wider">Founder</p>
              </div>
            </div>

            {/* Journey */}
            <div className="text-slate-600 text-[12px] leading-relaxed space-y-3">
              <p className="text-justify">
                The founder holds a Bachelor's degree in Civil Engineering and began his
                professional career with <strong>Larsen &amp; Toubro (L&amp;T)</strong>, working
                for 4 years. A strong passion for technology and digital innovation inspired a
                transition into the software domain.
              </p>
              <p className="text-justify">
                Starting with website development, an opportunity from a gym management client
                led to the first software product. This client-driven innovation became the
                foundation of BFI's growth strategy.
              </p>
              <p className="text-justify">
                Today, BFI stands as a leader in specialized automation, supporting laboratories
                and industries with solutions focused on{" "}
                <strong>compliance, efficiency, and operational excellence</strong>.
              </p>
            </div>
            <div className="clear-both" />
          </div>

          {/* philosophy */}
          <div className="mt-5 grid grid-cols-2 gap-3">
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100">
              <h3 className="text-sm font-teko uppercase text-slate-900 mb-1.5 tracking-wide">
                Our Philosophy
              </h3>
              <p className="text-[10px] italic text-slate-500 border-l-2 border-blue-600 pl-3 leading-relaxed">
                "Every software product at BFI is built from real industry problems."
              </p>
            </div>
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100">
              <h3 className="text-sm font-teko uppercase text-slate-900 mb-1.5 tracking-wide">
                Future Goals
              </h3>
              <ul className="space-y-1 text-[10px] text-slate-600">
                <li>• Global Software Expansion</li>
                <li>• AI-Driven Workflows</li>
              </ul>
            </div>
          </div>
        </div>

        {/* desktop layout */}
        <div className="hidden lg:flex gap-16 items-start relative">
          <div className="flex-1 space-y-5 text-slate-600 leading-relaxed text-[14px]" data-aos="fade-up">
            <div className="mb-6">
              <h2 className="text-3xl md:text-5xl font-teko uppercase text-slate-900 mb-4 tracking-wider">
                Founder's Journey
              </h2>
              <p className="text-slate-500 text-sm leading-relaxed max-w-4xl text-justify">
                BFI was founded in 2018 with a vision to transform traditional laboratory and
                industrial operations through smart, practical, and scalable software solutions.
                Every software product at BFI is built from real industry problems and practical
                client experiences.
              </p>
            </div>

            <p className="text-justify">
              The founder holds a Bachelor's degree in Civil Engineering and began his professional
              career with <strong>Larsen &amp; Toubro (L&amp;T)</strong>, where he worked for 4
              years in the engineering sector. During this period, a strong passion for technology
              and digital innovation inspired a transition from the construction industry into the
              software domain.
            </p>
            <p className="text-justify">
              The journey started with website development projects for businesses across different
              industries. While working closely with clients, an opportunity emerged from a gym
              management client, leading to the development of Gym Management Software. This
              client-driven innovation became the foundation of BFI's growth strategy.
            </p>
            <p className="text-justify">
              Soon after, a Third-Party Inspection (TPI) client introduced operational challenges
              faced in inspection workflows, which inspired the development of the TPI Management
              Application.
            </p>
            <p className="text-justify">
              Today, BFI stands as a leader in specialized automation, supporting laboratories and
              industries with solutions focused on{" "}
              <strong>compliance, efficiency, and operational excellence</strong>.
            </p>

            <div className="pt-6 grid grid-cols-2 gap-6">
              <div className="p-5 bg-slate-50 rounded-2xl border border-slate-100">
                <h3 className="text-lg font-teko uppercase text-slate-900 mb-2 tracking-wide">
                  Our Philosophy
                </h3>
                <p className="text-[11px] italic text-slate-500 border-l-2 border-blue-600 pl-4 leading-relaxed">
                  "Every software product at BFI is built from real industry problems and practical
                  client experiences."
                </p>
              </div>
              <div className="p-5 bg-slate-50 rounded-2xl border border-slate-100">
                <h3 className="text-lg font-teko uppercase text-slate-900 mb-2 tracking-wide">
                  Future Goals
                </h3>
                <ul className="space-y-1 text-[11px] text-slate-600">
                  <li>• Global Software Expansion</li>
                  <li>• AI-Driven Workflows</li>
                </ul>
              </div>
            </div>
          </div>

          {/* founder image */}
          <div className="w-80 flex flex-col items-end gap-4 mt-20" data-aos="fade-left">
            <div className="w-full relative group">
              <div className="relative overflow-hidden rounded-[2rem] shadow-xl border-4 border-white bg-slate-50 transition-all duration-500 hover:shadow-2xl">
                <img
                  className="w-full h-auto object-cover transition-all duration-700"
                  src={founder}
                  alt="Pravin Kashid"
                />
                <div className="absolute inset-0 bg-blue-900/40 opacity-0 hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                  <div className="text-white">
                    <p className="text-xl font-teko uppercase tracking-wider">Pravin Kashid</p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-blue-200">
                      Founder
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-4 px-2">
                <p className="text-[11px] text-slate-500 leading-relaxed text-right">
                  <strong>Pravin Kashid</strong> leads BFI with a vision to automate complex
                  industrial workflows through intuitive digital solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
